module.exports = __webpack_public_path__ + "static/Statiq-2fc9360e6194663eb5db1d5b43bfd5f2.png";